module.exports = __webpack_public_path__ + "static/media/img_tooltip.c498d521.svg";